export default __webpack_public_path__ + "static/no-props-f10910673c8c91a8a7399c74d9b5617b.png";